module.exports = __webpack_public_path__ + "img/Bing_Zeng@2x.ce91ac73.png";